var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSignIn = function SvgSignIn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 58 58"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#7B4EF8",
    strokeLinecap: "round",
    clipPath: "url(#sign-in_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.055 19.693v-6.987a11.67 11.67 0 0 0-3.408-8.229 11.63 11.63 0 0 0-8.215-3.415h-5.755a11.63 11.63 0 0 0-8.214 3.415 11.67 11.67 0 0 0-3.408 8.23v32.602a11.67 11.67 0 0 0 3.408 8.23 11.63 11.63 0 0 0 8.214 3.414h5.755a11.63 11.63 0 0 0 8.215-3.414 11.67 11.67 0 0 0 3.408-8.23v-6.986M16.867 28.648H56.94"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "m43.773 16.125 12.522 12.522-12.522 12.521"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "sign-in_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h58v58H0z"
  })))));
};
export default SvgSignIn;